/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import TextareaAutosize from 'react-autosize-textarea'
import {
    Spinner, Pivot, IconButton, PersonaPresence, Persona, PersonaSize, TextField, DirectionalHint, SpinnerSize
} from '@fluentui/react';
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import moment from 'moment'
import uploadFileToBlob from '../../../../HelperComponents/azureBlob';
import { CommentMultiple32Regular, Camera24Regular } from '@fluentui/react-icons';
import { Button } from "@fluentui/react-components";
import $ from 'jquery'
const signalR = require("@microsoft/signalr");
const container = css`
    flex-direction: column-reverse!important;
    display: flex;
`;
const inputContainer = css`
       background-color: rgba(var(--palette-neutral-6), 1);
    border-radius: 3px;
        display: flex;
    width: 100%;
    flex-direction: column;
    padding: 4px;
`;
const iconButton = css`
.fui-Button{
    margin-left:10px;
    border: none;
    border-radius: 50%;
    .fui-Button__icon {
        height: 24px;
    width: 24px;
    }
}

`;
const REACTION_EMOJIS = [
    { slug: 'smile', char: '🙂' },
    { slug: 'laughing', char: '😂' },
    { slug: 'love', char: '😍' },
    { slug: 'surprised', char: '😮' },
    { slug: 'up', char: '👍' },
    { slug: 'down', char: '👎' },
    { slug: 'clap', char: '👏' },
];
const emojiForSlug = (slug) => {
    const found = REACTION_EMOJIS.find((e) => e.slug === slug);
    return found ? found.char : '';
};
class Chat extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            messages: [],
            messagesOriginal: [],
            multiline:false,
            loading: true,
            spinner: false,
            message: '',
            rows: 1,
            chatId: this.props.chatId,
            justify: null,
            page: 0,
            refreshing: false,
            containerWidth: null
        };
        this.messagesEndRef = React.createRef();
        this.fileUploadImageRef = React.createRef();
        this.fileUploadFileRef = React.createRef();
        this.containerRef = React.createRef();
        this.subContainerRef = React.createRef();
        this.loadedMessageIds = new Set();
    }

    componentDidMount() {
        this.getChat(true);
        
        const hubConnection = new signalR.HubConnectionBuilder().withUrl(AUTH_CONFIG.API_URL + '/TwilioHub', {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        }).build();

        this.setState({ hubConnection }, () => {
            this.state.hubConnection
                .start()
                .then(() => { })
                .catch(err => { });
            this.state.hubConnection.on('chatMessageUpdate', (response, replyText) => {
                debugger
                this.getChat(false);
            });
            this.state.hubConnection.on('chatMessageDelete', (response, replyText) => {
                var tmp = this.state.messagesOriginal.filter(x => x.chatMessageId != response.chatMessageId);
                this.setState({
                    messages: tmp.reverse(),
                    messagesOriginal: tmp
                }, () => {
                    this.scrollToBottom();
                });
            });
        });
        const element = document.getElementById(`ChatContainer${!this.props.expanded ? 'Exp' : ''}`);
        let lastScrollTop = 0;
        element.onscroll = (e) => {
            console.log(Math.abs(element.scrollTop))
            console.log(lastScrollTop)

            if (Math.abs(element.scrollTop) < lastScrollTop) {
                // upscroll 
                return;
            }
            lastScrollTop = Math.abs(element.scrollTop) <= 0 ? 0 : Math.abs(element.scrollTop);
            if (Math.abs(element.scrollTop) + Math.abs(element.offsetHeight) >= (Math.abs(element.scrollHeight - 1))) {
                debugger
                if (!this.state.refreshing && this.state.messages.length > 14) {
                    let tmp = this.state.page + 1;
                    this.setState({
                        page:tmp
                    }, () => this.getChat())
                }
            }
        }
        if (this.containerRef.current) {
            const containerWidth = this.containerRef.current.offsetWidth;
            this.setState({
                containerWidth: containerWidth * 0.5 + 'px', // 50% of the container's width
            });
        }
    }

    componentDidUpdate() {
        if (this.subContainerRef && this.subContainerRef.current && this.containerRef && this.containerRef.current) {
            var chCon = document.getElementsByClassName("ch-con")[0];
            var chSubCon = document.getElementsByClassName("ch-sub-con")[0];
            if (chSubCon.offsetHeight < chCon.offsetHeight) {
                chCon.style.justifyContent = "flex-end";
            } else {
                chCon.style.removeProperty('justify-content');
            }
        }
    }

    scrollToBottom = (behavior = "smooth") => {
        //this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
        

        if (this.props.expanded) {
            let scroll_to_bottom = document.getElementById('ChatContainer');
            if (scroll_to_bottom) scroll_to_bottom.scroll({ top: scroll_to_bottom.scrollHeight, behavior })
        } else {
            let scroll_to_bottom = document.getElementById('ChatContainerExp');
            if (scroll_to_bottom) scroll_to_bottom.scroll({ top: scroll_to_bottom.scrollHeight, behavior })
        }

        


        ////
        //if (!this.props.expanded) {
        //    var elmnt = document.getElementById("ScrollBottomBox");
        //    elmnt.scrollIntoView();
        //}
       
    }

    getChat = (showSpinner) => {
        if (showSpinner) {
            this.setState({ loading: true })
        }
        this.setState({ refreshing: true })
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetChat?chatid=" + this.state.chatId + '&page=' + this.state.page)
            .then((response) => {
                if (response.data.messages.length > 0) {
                    debugger;
                    const uniqueMessages = response.data.messages.filter(
                        (message) => !this.loadedMessageIds.has(message.chatMessageId)
                    );

                    let tmp = [...uniqueMessages, ...this.state.messagesOriginal,]
                    let tmp2 = [...uniqueMessages, ...this.state.messagesOriginal]

                    uniqueMessages.forEach((message) => this.loadedMessageIds.add(message.chatMessageId));

                    this.setState({
                        messages: tmp.reverse(),
                        messagesOriginal: tmp2
                    }, () => {
                        this.scrollToBottom();
                    });
                }
                this.setState({
                    loading: false,
                    refreshing:false
                });
                //setTimeout(function () {
                //    this.scrollToBottom();
                //}.bind(this), 200)
                //setTimeout(function () {
                //    this.scrollToBottom();
                //}.bind(this), 500)
                //setTimeout(function () {
                //    this.scrollToBottom();
                //}.bind(this), 1000)

                //setTimeout(function () {
                //    var myobj = document.getElementById("ChatLoading");
                //    if (myobj) {
                //        myobj.remove();
                //    }
                //}, 1000)
            });
    }

    componentWillReceiveProps(nextProps) {
        
        if (nextProps.chatId !== this.props.chatId) {
            this.setState({
                chatId: nextProps.chatId,
                messagesOriginal: [],
                messages:[],
            }, () => {
                this.loadedMessageIds.clear();
                this.getChat(true);
            })
           
        }
    }

    clickFileUpload =()=> {
        if (this.fileUploadFileRef.current) {
            this.fileUploadFileRef.current.click()
        }
    }

    clickImageUpload = () => {
        if (this.fileUploadImageRef.current) {
            this.fileUploadImageRef.current.click()
        }
    }

    onSendMessage = (e) =>{
        e.preventDefault();

        var model = {
            chatId: this.props.chatId,
            createdAt: moment().format('MM/DD/YYYY HH:mm:ss'),
            text: this.state.message.trim(),
            userId: this.props.userId,
            fname: this.props.user.firstName,
            lname: this.props.user.lastName,
            image: this.state.image ? this.state.image : undefined,
            aspectRatio: this.state.aspectRatio,
            attachment: this.state.attachment ? this.state.attachment : undefined,
            attachmentName: this.state.attachmentName ? this.state.attachmentName : undefined,
            activityDescription: this.props.item.activityDescription
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/ChatMessageAdd", model)
            .then((response) => {
                this.getChat(false);
            });
        this.setState({
            messages: this.state.messages,
            messagesOriginal: this.state.messagesOriginal,
            message: '',
            rows: 1,
            attachment: undefined,
            attachmentName: undefined,
            image:undefined
        }, () => {
            try {
                document.querySelector('#InputContainer .attachment-pill').remove();
                document.querySelector('.footer form').classList.remove("has-attachment");
            } catch { }
          
            //this.scrollToBottom();
        });

    }

    removeActive = () => {
        $('.message-thread-body').removeClass("active");
    }
    setActive = (id) => {
        
        $('#id' + id).addClass("active");
    }

    removeMessage = (id) => {
        var model = {
            ChatMessageId:id
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/ChatMessageDelete", model).then((response) => {
            this.setState((prevState) => ({
                messages: prevState.messages.filter((message) => message.chatMessageId !== id),
                messagesOriginal: prevState.messagesOriginal.filter((message) => message.chatMessageId !== id),
            }));
        });
       
    }

    updateMessageLikes = (chatMessageId, likes, myReaction) => {
        const apply = (arr) => arr.map((m) =>
            m.chatMessageId === chatMessageId ? { ...m, likes, myReaction } : m
        );
        this.setState((prevState) => ({
            messages: apply(prevState.messages),
            messagesOriginal: apply(prevState.messagesOriginal),
        }));
    }

    toggleReaction = (item, slug) => {
        if (item.myReaction === slug) {
            this.removeReaction(item, slug);
        } else {
            this.addReaction(item, slug);
        }
    }

    addReaction = (item, slug) => {
        const model = { chatMessageID: item.chatMessageId, slug };
        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/AddChatLike", model)
            .then((response) => {
                this.updateMessageLikes(item.chatMessageId, response.data, slug);
            });
    }

    removeReaction = (item, slug) => {
        const model = { chatMessageID: item.chatMessageId, slug };
        axios.post(AUTH_CONFIG.API_URL + "/api/Schedules/RemoveChatLike", model)
            .then((response) => {
                this.updateMessageLikes(item.chatMessageId, response.data, null);
            });
    }

    messageListItem = (item, i) => {
        var same = false
        if (i > 0) {
            same = this.state.messages[i].user.userId == this.state.messages[i - 1].user.userId;
        }
        return <div class="message-list-item" key={item.createdAt}>
           
            <div className={this.props.user.userId == item.user.userId ? 'self message' : 'message'}>
                <div class="thread-body">
                    <div class="media-left">
                        {(this.props.user.userId != item.user.userId) && !same && 
                            <Persona
                            imageUrl={item.user.profileImage ? process.env.REACT_APP_CDN_URL + item.user.profileImage : null}
                                imageInitials={item.user.firstName.substring(0, 1) + item.user.lastName.substring(0, 1)}
                                initialsColor={item.user.avatarColor}
                                size={PersonaSize.size32}
                                hidePersonaDetails
                            />
                        }
                    </div>
                    <div class="message-thread-body-container">
                        {(this.props.user.userId != item.user.userId) && !same &&
                            <div class="message-body-top-row ">
                                <div class="top-row-text-container">
                                    <div className="user-name">{item.user.firstName} {item.user.lastName}</div>
                                    <div class="timestamp-column">
                                        {moment(item.createdAt).format('M/D h:mm A')}
                                    </div>
                                </div>
                            </div>
                        }

                        {(item.text && this.props.user.userId == item.user.userId) && !same &&
                            <div class="message-body-top-row ">
                                <div class="top-row-text-container">
                                    <div class="timestamp-column">
                                        {moment(item.createdAt).format('M/D h:mm A')}
                                    </div>
                                </div>
                            </div>
                        }

                        <div class="message-thread-body" id={"id" + item.chatMessageId}>
                            <div className="chat-reaction-bar">
                                {REACTION_EMOJIS.map((e) => (
                                    <button
                                        key={e.slug}
                                        type="button"
                                        className={item.myReaction === e.slug ? 'active' : ''}
                                        onClick={() => this.toggleReaction(item, e.slug)}
                                        title={e.slug}
                                    >{e.char}</button>
                                ))}
                            </div>
                            <div className="flexcolumn ">
                                

                                {item.text &&
                                    <div className="message-body-container">
                                        <div>{item.text}</div>
                                    </div>
                                }
                                {item.image &&
                                    <div className="message-body-container">
                                        <a href={AUTH_CONFIG.CDN_URL + `/images/clients/${this.props.clientID}/chat/${this.props.chatId}/` + item.image} target="_blank" style={{ width: this.state.innerDivWidth, maxWidth: 240, aspectRatio: `${item.aspectRatio}` }} rel="noreferrer">
                                            <img
                                                src={AUTH_CONFIG.CDN_URL + `/images/clients/${this.props.clientID}/chat/${this.props.chatId}/` + item.image}
                                                style={{ width: '100%', maxWidth: 240 }}
                                                onLoad={() => this.scrollToBottom("auto")}
                                                onError={(e) => {
                                                    if (!e.target.dataset.fallback) {
                                                        e.target.dataset.fallback = '1';
                                                        const legacy = AUTH_CONFIG.CDN_URL + `/images/clients/${this.props.clientID}/` + item.image;
                                                        e.target.src = legacy;
                                                        if (e.target.parentNode && e.target.parentNode.tagName === 'A') {
                                                            e.target.parentNode.href = legacy;
                                                        }
                                                    }
                                                }}
                                            />
                                        </a>
                                    </div>
                                }
                                {item.attachment &&
                                    <div className="message-body-container has-attachment">
                                        <a href={AUTH_CONFIG.CDN_URL + `/files/clients/${this.props.clientID}/` + item.attachment} className="displayflex" target="_blank" rel="noreferrer">
                                            <div class="attachment-pill white"><div class="aligncenter displayflex">
                                                {!item.attachment.match(/.(jpg|jpeg|png|gif)$/i) &&
                                                    <svg role="presentation" viewBox="0 0 32 32" focusable="false" style={{ width: 25, marginRight: 5 }}>
                                                        <g class="app-files-icon">
                                                            <path d="M6.5 29H25.5C25.775 29 26 28.775 26 28.5V9H21.5C20.673 9 20 8.327 20 7.5V3H6.5C6.225 3 6 3.225 6 3.5V28.5C6 28.775 6.225 29 6.5 29Z" fill="white"></path>
                                                            <path d="M25.293 8.00003L21 3.70703V7.50003C21 7.77503 21.225 8.00003 21.5 8.00003H25.293Z" fill="white"></path>
                                                            <path opacity="0.64" fill-rule="evenodd" clip-rule="evenodd" d="M26.56 7.854L21.146 2.439C20.8642 2.15891 20.4833 2.00117 20.086 2H6.5C5.673 2 5 2.673 5 3.5V28.5C5 29.327 5.673 30 6.5 30H25.5C26.327 30 27 29.327 27 28.5V8.914C27 8.514 26.844 8.137 26.56 7.854ZM21 3.707L25.293 8H21.5C21.2241 7.99945 21.0005 7.77591 21 7.5V3.707ZM6.5 29H25.5C25.775 29 26 28.775 26 28.5V9H21.5C20.673 9 20 8.327 20 7.5V3H6.5C6.225 3 6 3.225 6 3.5V28.5C6.00055 28.7759 6.22409 28.9995 6.5 29Z" fill="#605E5C"></path>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 13H8.5C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12H23.5C23.7761 12 24 12.2239 24 12.5C24 12.7761 23.7761 13 23.5 13ZM23.5 15H8.5C8.22386 15 8 14.7761 8 14.5C8 14.2239 8.22386 14 8.5 14H23.5C23.7761 14 24 14.2239 24 14.5C24 14.7761 23.7761 15 23.5 15ZM8.5 17H23.5C23.7761 17 24 16.7761 24 16.5C24 16.2239 23.7761 16 23.5 16H8.5C8.22386 16 8 16.2239 8 16.5C8 16.7761 8.22386 17 8.5 17Z" fill="#C8C6C4"></path>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 19H19C20.1046 19 21 19.8954 21 21V25C21 26.1046 20.1046 27 19 27H13C11.8954 27 11 26.1046 11 25V21C11 19.8954 11.8954 19 13 19ZM20 21C20 20.449 19.551 20 19 20H13C12.449 20 12 20.449 12 21V25C12 25.551 12.449 26 13 26H19C19.551 26 20 25.551 20 25V21ZM5 26H9.75C9.88807 26 10 25.8881 10 25.75V20.25C10 20.1119 9.88807 20 9.75 20H5C4.44772 20 4 20.4477 4 21V25C4 25.5523 4.44772 26 5 26ZM22.25 20H27C27.5523 20 28 20.4477 28 21V25C28 25.5523 27.5523 26 27 26H22.25C22.112 26 22 25.888 22 25.75V20.25C22 20.1119 22.1119 20 22.25 20Z" fill="#D65532"></path>
                                                        </g>
                                                    </svg>
                                                }
                                                {item.attachment.match(/.(jpg|jpeg|png|gif)$/i) &&

                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style={{ width: 25, marginRight: 5 }}><path fill="#FFF" d="M3.5 17h13c.275 0 .5-.225.5-.5v-13c0-.275-.225-.5-.5-.5h-13c-.275 0-.5.225-.5.5v13c0 .275.225.5.5.5z" /><path fill="none" stroke="#A6CCC3" stroke-miterlimit="10" d="M11.691 10.657l-.878 1.286-1.687-2.326a1 1 0 00-1.619 0l-2.39 3.296a1 1 0 00.81 1.587h8.146a1 1 0 00.826-1.564l-1.556-2.28a1 1 0 00-1.652 0z" /><circle fill="none" stroke="#FF9810" stroke-miterlimit="10" cx="13.5" cy="6.5" r="1" /><path opacity=".64" fill="#605E5C" d="M16.5 18h-13c-.827 0-1.5-.673-1.5-1.5v-13C2 2.673 2.673 2 3.5 2h13c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5zM3.5 3a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-13z" /></svg>
                                                }
                                                <span style={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.attachmentName ? item.attachmentName : item.attachment}</span> </div></div>
                                        </a>
                                    </div>
                                }
                            </div>

                            
                                {(this.props.user.userId == item.user.userId) &&
                                <div className="ml10" style={{ width: 39 }}><IconButton
                                        menuIconProps={{ iconName: 'More' }}
                                        role="button"
                                        className="list-more-button chat"
                                        aria-haspopup={true}
                                        aria-label="Show actions"
                                        styles={{ root: { float: 'right', height: 'inherit' } }}
                                        onAfterMenuDismiss={() => this.removeActive()}
                                        onMenuClick={() => { this.setActive(item.chatMessageId) }}
                                    menuProps={{
                                        directionalHint: DirectionalHint.bottomRightEdge,
                                        className: 'publish-dropdown',
                                        calloutProps: {
                                            styles: {
                                                root: {
                                                    border: '1px solid rgba(var(--palette-neutral-100), 0.18)',
                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2.4px 5.4px 0px, rgba(0, 0, 0, 0.0807) 0px 1.2px 1.6px 0px',
                                                    borderRadius: 5, overflow: 'hidden'
                                                },
                                            },
                                        },

                                            items: [{
                                                key: 'delete',
                                                text: 'Delete',
                                                iconProps: { iconName: 'Delete' },
                                                onClick: () => this.removeMessage(item.chatMessageId)
                                            },
                                                //{
                                                //key: 'rename',
                                                //text: 'Edit',
                                                //iconProps: { iconName: 'Edit' },
                                                //onClick: () => { window.location.href = `mailto:${item.email}`; }
                                                //}
                                            ]
                                        }}
                                /> </div>
                                }
                           
                         
                        </div>
                        {item.likes && item.likes.length > 0 &&
                            <div className="reaction-badges">
                                {item.likes.map((l) => (
                                    <button
                                        key={l.slug}
                                        type="button"
                                        className={item.myReaction === l.slug ? 'mine' : ''}
                                        onClick={() => this.toggleReaction(item, l.slug)}
                                    >
                                        <span>{emojiForSlug(l.slug)}</span>
                                        {l.count > 1 && <span className="count">{l.count}</span>}
                                    </button>
                                ))}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }

    onChange = (ev, newText) => {
        this.setState({
            message: ev.target.value,
        });
    };

    getUniqueFileName = (originalName, shortId) => {
        const dotIndex = originalName.lastIndexOf(".");
        if (dotIndex === -1) return `${originalName}_${shortId}`; // no extension fallback

        const name = originalName.slice(0, dotIndex).replace(/\s+/g, '_');
        const ext = originalName.slice(dotIndex);
        return `${name}_${shortId}${ext}`;
    };

    onImageChange = async (event) => {
        var file = event.target.files[0];
        const shortId = Math.random().toString(36).substring(2, 6);
        const uniqueFileName = this.getUniqueFileName(file.name, shortId);
        const renamedFile = new File([file], uniqueFileName, { type: file.type });

        this.setState({
            uploading: true,
            image: renamedFile.name,
        });
        const imageURL = URL.createObjectURL(file);
        const img = new Image();
        img.src = imageURL;

        img.onload = async () => {
            const aspectRatio = img.width / img.height;

           
            await uploadFileToBlob(renamedFile, `images/clients/${this.props.clientID}/chat/${this.props.chatId}`);

            this.setState({
                uploading: false,
                aspectRatio, // Optional: store the aspect ratio in state if needed
            });

            // Clean up the created object URL
            URL.revokeObjectURL(imageURL);

            this.onSendMessage(event);
        };

    };

    onFileChange = async (event) => {
        var file = event.target.files[0];
        const shortId = Math.random().toString(36).substring(2, 6);
        const uniqueFileName = this.getUniqueFileName(file.name, shortId);
        const renamedFile = new File([file], uniqueFileName, { type: file.type });

        this.setState({
            uploading: true,
            attachment: renamedFile.name,
            attachmentName: renamedFile.name
        });

        // *** UPLOAD TO AZURE STORAGE ***
        await uploadFileToBlob(renamedFile, `files/clients/${this.props.clientID}`);

        this.setState({
            uploading: false
        });
        //this.onSendMessage(event)

        var html = `<div class="attachment-pill mt10"><div class="aligncenter displayflex"><i class="ms-Icon ms-Icon--TextDocument"></i> ${file.name} </div><i class="clear-file hover-cursor ms-Icon close-b ms-Icon--ChromeClose"></i></div>`
        document.querySelector(`${this.props.page ? "." + this.props.page : ''} #InputContainer`).insertAdjacentHTML('beforeend', html);
        document.querySelector(`${this.props.page ? "." + this.props.page : ''} .footer form`).classList.add("has-attachment");
        var that = this;
        document.querySelector(`${this.props.page ? "." + this.props.page : ''} .clear-file`).onclick = function () {
            that.setState({
                uploading: false,
                attachment: null,
                attachmentName: null
            });
            document.querySelector(`${that.props.page ? "." + that.props.page : ''} #InputContainer .attachment-pill`).remove();
            document.querySelector(`${that.props.page ? "." + that.props.page : ''} .footer form`).classList.remove("has-attachment");
        }
    };

    render() {
        return (
            <div className={`${this.props.page} displayflex flexcolumn chat height100 width100`} style={{position:'relative', }}>
               
                <div id={`ChatContainer${!this.props.expanded ? 'Exp' : ''}`} css={container} ref={this.containerRef} className="ch-con custom-scrollbar pr20 pl15 mb10" style={{
                    height: this.props.page ? 'calc(100% - 90px)' : 'calc(100% - 70px)'
                }}>
                    {!this.state.loading && this.state.messages.length > 0 &&
                        <div style={{ maxWidth: 1000, marginRight: 'auto', marginLeft: 'auto' }} ref={this.subContainerRef} className="ch-sub-con flexcolumn width100">
                            {!this.state.loading &&
                                this.state.messages.map((item, i) => {
                                    return this.messageListItem(item, i)
                                })
                        }

                        </div>
                    }
                   
                    {this.state.messages.length == 0 &&
                        <div className="displayflex justifycenter height100 " style={{ maxWidth: 1000, margin: 'auto' }}>
                            <div className="displayflex flexcolumn height100 aligncenter justifycenter">
                                <CommentMultiple32Regular style={{ color: 'var(--text-secondary-color)' }} />
                                <h4 className="head-s mt15" style={{ color: 'var(--text-secondary-color)', fontSize: 14 }}>No Messages</h4>
                            </div>
                        </div>
                    }
                   
                    {this.props.expanded &&
                        <div ref={this.messagesEndRef} id="ScrollBottom" />
                    }
                    {!this.props.expanded &&
                        <div ref={this.messagesEndRef} id="ScrollBottomBox" />
                    }
                    
                   
                    <input style={{ display: 'none' }} ref={this.fileUploadFileRef} type="file" onChange={this.onFileChange} />
                    <input style={{ display: 'none' }} ref={this.fileUploadImageRef} type="file" onChange={this.onImageChange} />
                </div>
                <div className={`footer pabsolute`}>
                    <form className="displayflex width100 f-inp" onSubmit={(e) => this.onSendMessage(e) }>
                        <div css={ inputContainer } id="InputContainer">
                        <TextareaAutosize
                            className="displayflex aligncenter width100 mr5"
                            placeholder="Type a message..."
                            style={{ border:'none', padding:10, height: 'auto', backgroundColor: 'rgba(var(--palette-neutral-6), 1)', borderRadius: 3, width: '100%' }} onChange={this.onChange} value={this.state.message} />

                        </div>
                        {(this.state.message || this.state.attachment) &&
                            <IconButton
                                styles={{icon: { color: "var(--themeBtnBlue) !important",fontSize: 20 }}}
                                iconProps={{ iconName: 'Send' }}
                                onClick={(e)=>this.onSendMessage(e)}
                            />
                        }
                    </form>
                    {!this.state.message && !this.state.attachment &&
                        <div className="displayflex" css={iconButton }>
                            <Button icon={<Camera24Regular />} onClick={this.clickImageUpload} />
                        {/*<IconButton*/}
                        {/*    styles={{*/}
                        {/*        root: {*/}
                        {/*            color: "black",*/}
                        {/*        },*/}
                        {/*        icon: { fontSize: 18 },*/}
                        {/*        rootHovered: {*/}
                        {/*            color: "black",*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*    iconProps={{ iconName: 'Attach' }}*/}
                        {/*    onClick={this.clickFileUpload}*/}
                        {/*/>*/}
                    </div>
                    }
                   
                </div>
                {this.state.loading &&
                    <div id="ChatLoading" className="displayflex aligncenter justifycenter " style={{ height: 'calc(100% - 70px)', position: 'absolute', top: 0, right: 0, left: 0, }}>
                        <Spinner size={SpinnerSize.medium} />
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const facilityId = state.appState.product.facility.facilityID;
    const clientID = state.appState.clientID;
    const product = state.appState.product.slug
    const user = state.userProfile;
    const facilityName = state.appState.product.facility.name;
    const userId = state.userProfile.userId;
    return {
        facilityId,
        clientID,
        user,
        product,
        facilityName,
        userId
    }
}


export default connect(mapStateToProps)(Chat);

